export const appHead = {"meta":[{"charset":"utf8"},{"content":"width=device-width, initial-scale=1","name":"viewport"},{"content":"Revolugo Platform","hid":"description","name":"description"}],"link":[{"href":"/favicon.ico","rel":"icon","type":"image/x-icon"}],"style":[],"script":[{"async":true,"defer":true,"id":"hs-script-loader","onload":"window.FrontChat('init', {chatId: '91ce129461ef6e2a565e54c81b2079e4', useDefaultLauncher: true})","src":"https://chat-assets.frontapp.com/v1/chat.bundle.js"}],"noscript":[],"title":"Revolugo","titleTemplate":"%s | Revolugo"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false